<template>
  <div>

    <wc-data-box
      :title='stickiesHeader.title'
      :titleIcon='stickiesHeader.icon'
      :titleIconColor='stickiesHeader.iconColor'
      :loading='isLoading'
    >
      <template v-slot:toolbarButtons>
        <v-btn small color='primary' width='76px' depressed @click='addSticky'>
          <v-icon small left>mdi-plus</v-icon>
          Add
        </v-btn>
      </template>
      <v-card-text v-if='stickies.length === 0'>
        None...
      </v-card-text>
      <div v-else>
        <template v-for='(s, index) in sortedStickies'>
          <v-divider v-if='index > 0' :key='s.id'></v-divider>
          <v-card flat :key="index + '-' + s.id" @click='editSticky(s)'>
            <v-card-subtitle class='pb-2 d-flex align-baseline'>
              <wc-avatar v-if='s.created_by' :profile='s.created_by_obj'></wc-avatar>
              <span class='mx-2 heading-6'>{{ s.date_created | shortDate }}</span>
              <small v-if='s.time'>{{ s.time | time }}</small>
            </v-card-subtitle>
            <v-card-text>
              <span class='black--text'>{{ s.description }}</span>
            </v-card-text>
          </v-card>
        </template>
      </div>
    </wc-data-box>

    <wc-dialog
      :showDialog='showStickiesDialog'
      :title='stickiesHeader.title'
      :icon='stickiesHeader.icon'
      :iconColor='stickiesHeader.iconColor'
      :loadingButtons='isLoading'
      :disableButtons='stickyCopy.created_by !== $store.state.auth.profile.id'
      @cancel='showStickiesDialog = false'
      @save='saveSticky'
    >
      <v-form v-model='isStickyFormValid'>
        <v-textarea
          :readonly='stickyCopy.created_by !== $store.state.auth.profile.id'
          outlined
          v-model='stickyCopy.description'
          hint='Most stickies will be processed within a few days.  If your communication is more urgent please text or call your supervisor directly'
          persistent-hint
        ></v-textarea>
      </v-form>
      <v-alert dense border='left' v-if='stickyCopy.created_by !== $store.state.auth.profile.id' type='warning'>You cannot edit a sticky made by someone else</v-alert>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import projectsAPI from '@/modules/projects/api/projects'
import estimatesAPI from '@/modules/estimates/api/estimates'
import miscServices from '@/services/misc'
import moment from 'moment' 

export default {
  name: 'fc-stickies',
  props: {
    wo: {
      required: true
    },
  },
  mounted () {
    if (this.wo && this.wo.project) {
      this.getStickies()
    }
  },
  data: () => ({
    isStickyFormValid: false,
    showStickiesDialog: false,
    stickies: [],
    stickyCopy: {},
    isLoading: false,
  }),
  computed: {
    stickiesHeader () {
      return this.$store.state.icons.dataBox.stickies
    },
    sortedStickies () {
      // return _.orderBy(this.stickies, ['date_created', 'time'], ['desc', 'desc'])
      // re-instate sort by time if/when we add that field to the sticky
      return _.orderBy(this.stickies, ['date_created', 'id'], ['desc', 'desc'])
    }
  },
  methods: {
    async getStickies () {
      this.isLoading = true
      if (this.wo.project) {
        this.stickies = await projectsAPI.getProjectStickies(this.wo.project)
      } else if (this.wo.estimate) {
        this.stickies = await estimatesAPI.getEstimateStickies(this.wo.estimate)
      } else {
        this.stickies = []
      }
      this.isLoading = false
    },
    resetSticky () {
      this.stickyCopy.id = null
      this.stickyCopy.created_by = this.$store.state.auth.profile.id
      this.stickyCopy.date_created = moment().format('YYYY-MM-DD')
      this.stickyCopy.is_time_sensitive = false
      this.stickyCopy.is_highlighted = false
      this.stickyCopy.description = ''
      if (this.wo.project) {
        this.stickyCopy.project = this.wo.project
        this.stickyCopy.estimate = null
      } else if (this.wo.estimate) {
        this.stickyCopy.project = null
        this.stickyCopy.estimate = this.wo.estimate
      } else {
        // this step should never happen - MJ
        this.stickyCopy.project = null
        this.stickyCopy.estimate = null
      }
    },
    addSticky () {
      this.resetSticky()
      this.showStickiesDialog = true
    },
    editSticky (s) {
      this.stickyCopy = _.cloneDeep(s)
      this.showStickiesDialog = true
    },
    async saveSticky () {
      this.isLoading = true
      let tmp
      if (this.stickyCopy.id) {
        if (this.stickyCopy.project) {
          tmp = await projectsAPI.updateProjectSticky(this.stickyCopy)
        } else if ( this.stickyCopy.estimate) {
          tmp = await estimatesAPI.updateEstimateSticky(this.stickyCopy)
        }
        this.stickies = miscServices.replaceObject(this.stickies, tmp)
      } else {
        if (this.stickyCopy.project) {
          tmp = await projectsAPI.addProjectSticky(this.stickyCopy)
        } else if ( this.stickyCopy.estimate) {
          tmp = await estimatesAPI.addEstimateSticky(this.stickyCopy)
        }
        this.stickies.push(tmp)
      }
      this.showStickiesDialog = false
      this.isLoading = false
    },
  }
}
</script>